module.exports = "/images/trail-5.jpg";